import { usePatientParamContext } from "@/modules/patients/stores/PatientParamProvider"

export const useAppointmentParam = () => {
  const { appointmentId } = usePatientParamContext()
  return appointmentId
}

export const useIsInContextOfAppointment = () => {
  const appointmentId = useAppointmentParam()

  return !!appointmentId
}
